import { ServerUrlService } from 'src/app/services/server-url.service';
import { Router } from '@angular/router';
import { AsaasService } from './../../services/asaas.service';
import { MY_FORMATS } from '../cadastro/cadastro.component';
import { AbstractControl, FormControl, Validators } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatSnackBar } from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { LocalidadesService } from 'src/app/services/localidades.service';
import { Cep } from 'src/app/interfaces/cep';
import { Municipio } from 'src/app/interfaces/municipio';
import { Uf } from 'src/app/interfaces/uf';
import { Subscription, Observable } from 'rxjs';
import { startWith, map, debounceTime } from 'rxjs/operators';
import { MatInput } from '@angular/material/input';

import {
  Component,
  OnInit,
  ViewChild,
  Input,
  Output,
  EventEmitter
} from '@angular/core';

@Component({
  selector: 'app-cadastro-asaas',
  templateUrl: './cadastro-asaas.component.html',
  styleUrls: ['./cadastro-asaas.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'pt-br' },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class CadastroAsaasComponent implements OnInit {

  notify: string;
  @Input() stepper: any;
  @Output() userLgdIn = new EventEmitter<any>();
  @Input() userRegister: any;

  private observable: Observable<any>;
  subscription: Subscription;

  cpf: string;
  cnpj: string;

  instructionsMode: boolean = false;

  disabled: boolean = false;

  senha: string;
  senhaConf: string;
  date = new FormControl();
  smallScreen: boolean;
  formSend = false;

  cpfCnpjControl = new FormControl('', this.isValidCpf());
  ConfirmaControl = new FormControl();
  EmailControl = new FormControl('', Validators.pattern(/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i));
  CelularControl = new FormControl();
  LogradouroControl = new FormControl();
  MunicipioControl = new FormControl();
  EstadoControl = new FormControl();
  BairroControl = new FormControl();

  userData: any = {};

  action: string;
  cepHint: string;
  cepError: string;

  cpfError: string;

  municipiosList: [Municipio];
  estadosList: [Uf];

  cpfCnpjMask: string;
  placeholderCpfCnpj: string

  estadoRef: Subscription = null;
  municipioRef: Subscription = null;

  filteredMunicipioOptions: Observable<string[]>;
  optionsMunicipio: string[] = [];

  filteredRuaOptions: Observable<string[]>;
  optionsRua: string[] = [];

  // tslint:disable-next-line: no-inferrable-types
  grauParentesco: any = [];
  successForm = false;
  continueForm = false;
  @ViewChild('myFone') myFone: MatInput;

  constructor(
    private asaasService: AsaasService,
    breakpointObserver: BreakpointObserver,
    private localidades: LocalidadesService,
    private router: Router,
    private _snackBar: MatSnackBar,
    private serverUrl: ServerUrlService
  ) {

    if (localStorage.getItem("instructionMode")) {
      this.instructionsMode = JSON.parse(localStorage.getItem("instructionMode"))
    }

    this.observable = this.asaasService.ObservableRes()

    this.placeholderCpfCnpj = '';
    // Detecta o tamanho da janela (Desktop/Mobile)
    this.smallScreen = (window.innerWidth <= 400) ? true : false;
    breakpointObserver.observe([
      Breakpoints.XSmall,
      Breakpoints.Small
    ]).subscribe(result => {
      this.smallScreen = result.matches;
    });

    this.municipioRef = this.localidades.municipioEnd$.subscribe(() => {
      this.municipiosList = this.localidades.getAllMunicipios();
      this.refreshCityList('');
    });

    this.filteredMunicipioOptions = this.MunicipioControl.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filterMunicipio(value))
    );

    this.filteredRuaOptions = this.LogradouroControl.valueChanges
      .pipe(
        startWith(''),
        debounceTime(400),
        map(value => this._filterRua(value))
      );

    if (this.userData.personType === 'JURIDICA') {
      this.placeholderCpfCnpj = 'CNPJ'
      this.cpfCnpjMask = '00.000.000/0000-00'
    } else if (this.userData.personType === 'FISICA') {
      this.placeholderCpfCnpj = 'CPF'
      this.cpfCnpjMask = '000.000.000-00'
    }

    this.userData = {
      name: '',
      email: '',
      cpfCnpj: '',
      companyType: '',
      phone: '',
      mobilePhone: '',
      address: '',
      addressNumber: '',
      complement: '',
      province: '',
      postalCode: '',
      personType: '',
      city: '',
      state: '',
    };

    const userString = sessionStorage.getItem('userData');

    this.estadoRef = this.localidades.ufEnd$.subscribe(() => {
      setTimeout(() => {
        this.estadosList = this.localidades.getAllUf();
        this.estadosList.sort((a: any, b: any) => {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        });

        if (this.userData.estado) {
          this.EstadoControl.setValue(this.userData.estado);
        }
      }, 1000);

    });

    this.EstadoControl.valueChanges.subscribe((val) => {
      if (val) {
        this.refreshCityList(val);
      }
    });

    if (this.cpfError) {
      console.error('Cpf Error', this.cpfError)
    }

  }

  ngOnInit() {
    
  }

  private _filterMunicipio(value: string): string[] {
    const filterValue = value && value.toLowerCase();

    if (filterValue === '') {
      return [];
    }
    return this.optionsMunicipio.filter(option => option.toLowerCase().includes(filterValue));
  }

  private _filterRua(value: string): string[] {
    const filterValue = value && value.toLowerCase();

    return this.optionsRua.filter(option => option.toLowerCase().includes(filterValue));
  }

  private refreshCityList(filter: string) {
    let CheckCityInputed: boolean;
    CheckCityInputed = false;
    this.optionsMunicipio = [];

    if (this.municipiosList && this.municipiosList.length) {
      this.municipiosList.forEach(ele => {

        if (filter === '') {
          this.optionsMunicipio.push(ele.nome);
          CheckCityInputed = true;
        } else {
          if (filter === ele.microrregiao.mesorregiao.UF.sigla) {
            this.optionsMunicipio.push(ele.nome);
            if (this.MunicipioControl.value === ele.nome) {
              CheckCityInputed = true;
            }
          }
        }

      });
    }
  }

  onRegistrarPressed() {
    this.disabled = true;

    this.validaFormulario()

    if (this.continueForm === true) {

      if(this.userData.responsaveis) {
        const responsaveisArray = JSON.parse(this.userData.responsaveis)
        if(responsaveisArray.length > 0) {
          this.userData.name = responsaveisArray[0].nome
          this.userData.cpfCnpj = responsaveisArray[0].cpf
        }
      }

      const registro = {
        name: this.userData.name,
        email: this.userData.email,
        cpfCnpj: this.userData.cpfCnpj,
        companyType: this.userData.personType === 'FISICA' ? '' : this.userData.companyType,
        phone: this.userData.phone,
        mobilePhone: this.userData.mobilePhone,
        address: this.userData.address,
        addressNumber: this.userData.addressNumber,
        complement: this.userData.complement,
        province: this.userData.province,
        postalCode: this.userData.postalCode,
        personType: this.userData.personType,
        city: this.userData.city,
        state: this.userData.state,
      };
      delete registro.city;

      this.asaasService.registerUser(registro)
      
      this.subscription = this.observable.subscribe(
        (res: any) => {
        if (res.errors) {
          const errorList = []
          res.errors.map(item => {
            errorList.push(item.description)
          })
          const errors = errorList.toString()
          this._snackBar.open(errors, 'Ok')
          this.disabled = false; 
        } else if (!res.errors && res) {
          this._snackBar.open('Cadastro efetuado com sucesso!', 'Ok')
          this.instructionsMode = true;
          this.disabled = false;
          localStorage.setItem("instructionMode", "true")
        }
      })
    }
  }

  onVoltarClick() {
    this.userLgdIn.emit();
  }

  voltaClient() {
    this.router.navigate([`${this.serverUrl.getName()}/client`])
  }

  onChangeCEP() {
    if (this.userData.postalCode.length === 8) {
      this.cepError = '';
      this.localidades.searchCep(this.userData.postalCode)
        .subscribe(
          data => {
            const myData: any = data;
            const myCep: Cep = myData;
            if (myCep.erro === true) {
              // CEP não localizado
              this.cepHint = 'Cep não localizado.';
              this.MunicipioControl.enable();
              this.EstadoControl.enable();
              this.BairroControl.enable();
              this.LogradouroControl.enable();
            } else {
              this.cepHint = '';
              this.userData.province = myCep.bairro || '';
              this.userData.city = myCep.localidade || '';
              this.userData.state = myCep.uf || '';
              this.userData.address = myCep.logradouro || '';

              if (myCep.localidade !== '') { this.MunicipioControl.disable(); } else { this.MunicipioControl.enable(); }
              if (myCep.uf !== '') { this.EstadoControl.disable(); } else { this.EstadoControl.enable(); }
              if (myCep.bairro !== '') { this.BairroControl.disable(); } else { this.BairroControl.enable(); }
              if (myCep.logradouro !== '') { this.LogradouroControl.disable(); } else { this.LogradouroControl.enable(); }
            }
          }
        );
    } else {
      this.cepError = 'CEP Incompleto!';
      this.MunicipioControl.enable();
      this.EstadoControl.enable();
      this.BairroControl.enable();
      this.LogradouroControl.enable();
    }
  }

  validaFormulario() {

    let retorno = true;
    this.continueForm = true;

    if (!this.userData.email) {
      retorno = false;
    }

    if (!this.userData.name) {
      retorno = false;
    }

    if (!this.userData.cpfCnpj) {
      retorno = false;

      if(this.userData.responsaveis) {
        const responsaveisArray = JSON.parse(this.userData.responsaveis)
        const responsavelCpf = responsaveisArray.length > 0 ? responsaveisArray[0].cpf : '';
        if(responsavelCpf) retorno = true
      }
    }

    if (!this.userData.mobilePhone || this.userData.mobilePhone.length < 11) {
      this.CelularControl.setErrors({ 'incorrect': true });
      retorno = false;
    } else {
      this.ConfirmaControl.setErrors(null);
    }

    if (!this.userData.state) {
      retorno = false;
    }

    if (!this.userData.address) {
      retorno = false;
    }
    ''
    if (!this.userData.addressNumber) {
      retorno = false;
    }

    if (!this.userData.province) {
      retorno = false;
    }

    if (retorno === false) {
      this.continueForm = false;
    }
  }

  private isValidCpf() {
    return (control: AbstractControl): Validators => {
      const cpf = control.value;
      if (cpf.length === 11) {
        let numbers, digits, sum, i, result, equalDigits;
        equalDigits = 1;
        if (this.userData.personType === 'FISICA') {

          for (i = 0; i < cpf.length - 1; i++) {
            if (cpf.charAt(i) !== cpf.charAt(i + 1)) {
              equalDigits = 0;
              break;
            }
          }

          if (!equalDigits) {
            numbers = cpf.substring(0, 9);
            digits = cpf.substring(9);
            sum = 0;
            for (i = 10; i > 1; i--) {
              sum += numbers.charAt(10 - i) * i;
            }

            result = sum % 11 < 2 ? 0 : 11 - (sum % 11);

            if (result !== Number(digits.charAt(0))) {
              this.cpfError = 'CPF inválido'
              return { cpfNotValid: true };
            }
            numbers = cpf.substring(0, 10);
            sum = 0;

            for (i = 11; i > 1; i--) {
              sum += numbers.charAt(11 - i) * i;
            }
            result = sum % 11 < 2 ? 0 : 11 - (sum % 11);

            if (result !== Number(digits.charAt(1))) {
              this.cpfError = 'CPF Inválido'
              return { cpfNotValid: true };
            }
            return null;
          } else {
            this.cpfError = 'CPF Inválido'
            return { cpfNotValid: true };
          }
        }
      } else if (cpf.length === 14) {
        if (cpf == "00000000000000" ||
          cpf == "11111111111111" ||
          cpf == "22222222222222" ||
          cpf == "33333333333333" ||
          cpf == "44444444444444" ||
          cpf == "55555555555555" ||
          cpf == "66666666666666" ||
          cpf == "77777777777777" ||
          cpf == "88888888888888" ||
          cpf == "99999999999999")
          return false;

        // Valida DVs
        let tamanho = cpf.length - 2
        let numeros = cpf.substring(0, tamanho);
        let digitos = cpf.substring(tamanho);
        let soma = 0;
        let pos = tamanho - 7;
        for (let i = tamanho; i >= 1; i--) {
          soma += numeros.charAt(tamanho - i) * pos--;
          if (pos < 2)
            pos = 9;
        }
        let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado != digitos.charAt(0)) {
          this.cpfError = 'CNPJ Inválido'
          return { cpfNotValid: true };
        }

        tamanho = tamanho + 1;
        numeros = cpf.substring(0, tamanho);
        soma = 0;
        pos = tamanho - 7;
        for (let i = tamanho; i >= 1; i--) {
          soma += numeros.charAt(tamanho - i) * pos--;
          if (pos < 2)
            pos = 9;
        }
        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado != digitos.charAt(1)) {
          this.cpfError = 'CNPJ Inválido'
          return { cpfNotValid: true };
        }
      }
    }
  }

  private errorHandler(message) {
    
  }

}